import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { GdprConfiguration, GdprSaveBody } from '@core/gdpr-types';
import { I18nService } from '@core/i18n-legacy';
import { createEffectFactory } from '@core/ngrx-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

import { GdprConfigurationHttpClient } from './gdpr-configuration-http-client';
import { GdprConfigurationActions } from './gdpr-configuration.store';

@Injectable({ providedIn: 'root' })
export class GdprConfigurationEffects {
  private readonly gdprConfigurationHttpClient = inject(GdprConfigurationHttpClient);
  private readonly notificationController = inject(NotificationsController);
  private readonly i18n = inject(I18nService);
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(GdprConfigurationActions, this.actions$);

  public fetchGdprConfiguration$ = this.effect(GdprConfigurationActions.fetch, () =>
    this.gdprConfigurationHttpClient.fetch().pipe(filterBoolean),
  );

  public saveGdprConfiguration$ = this.effect(
    GdprConfigurationActions.update,
    ({ payload }: { payload: GdprSaveBody }) => this.gdprConfigurationHttpClient.save(payload),
  );

  public saveGdprNotification$ = this.effect(
    GdprConfigurationActions.updateSuccess,
    () => this.notificationController.success(this.i18n.translate('app.gdpr.form_saved')),
    { dispatch: false },
  );

  public toggleGDPRFeature$ = this.effect(
    GdprConfigurationActions.toggleGDPRFeature,
    ({ payload }) =>
      this.gdprConfigurationHttpClient.save(payload).pipe(
        switchMap((payload: GdprConfiguration) => [
          GdprConfigurationActions.toggleGDPRFeatureSuccess({
            payload,
          }),
        ]),
      ),
  );

  public toggleGDPRFeatureSuccess$ = this.effect(
    GdprConfigurationActions.toggleGDPRFeatureSuccess,
    data => {
      this.notificationController.success(
        this.i18n.translate(
          data.payload.enabled ? 'app.gdpr.gdpr_enabled' : 'app.gdpr.gdpr_disabled',
        ),
      );
    },
    { dispatch: false },
  );
}
